import React from 'react'
import className from 'classnames/bind'

import style from './MyhousePtpArticle.module.scss'

import MyhousePtpArticleItem from '@Components/modules/MyhousePtpArticle/MyhousePtpArticleItem'
import SvgMyhouseMainPtpArticleMore from '@Ui/images/myhouse/myhouse_main_ptpArticle--more.svg'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  articleList?: any
  totalCount?: any
  isSamePtpArticle?: boolean
  isSimilarPtpArticle?: boolean
  ptpArticleMoreInfoHandler?: any
  houseNo?: any
  inputStatus?: any //면적 입력 유무
}

const MyhousePtpArticle: React.FC<Props> = ({ articleList, totalCount, isSamePtpArticle, isSimilarPtpArticle, ptpArticleMoreInfoHandler, houseNo, inputStatus }: Props) => {
  return (
    <div id="myhouse_similar_ptp_article" className={cx('article')}>
      <div className={cx('title_area')}>
        {isSamePtpArticle ? (
          <>
            <h2 className={cx('title')}>동일 면적 매물</h2>
            <em className={cx('count')}>{totalCount}</em>
          </>
        ) : isSimilarPtpArticle ? (
          <>
            <h2 className={cx('title')}>유사 면적 매물</h2>
            <em className={cx('count')}>{totalCount}</em>
            <p className={cx('description')}>동일한 법정동 내 비슷한 면적(±10%)의 매물입니다.</p>
          </>
        ) : (
          <h2 className={cx('title')}>유사 면적 매물</h2>
        )}
      </div>
      {!inputStatus ? (
        <p className={cx('text')}>
          면적 정보를 입력하면 우리집과 유사한 면적의
          <br /> 매물 정보를 제공받을 수 있습니다.
        </p>
      ) : articleList.length > 0 ? (
        <ul className={cx('list')}>
          {articleList && isSamePtpArticle
            ? articleList.slice(0, 3).map((article: any, index: number) => {
                return <MyhousePtpArticleItem key={`ptp_article_${index}`} {...article} isSamePtpArticle />
              })
            : articleList.slice(0, 10).map((article: any, index: number) => {
                return <MyhousePtpArticleItem key={`ptp_article_${index}`} {...article} />
              })}
        </ul>
      ) : (
        <p className={cx('text', 'type_nodata')}>비슷한 면적의 매물이 없습니다.</p>
      )}
      {((isSamePtpArticle && totalCount > 0) || (isSimilarPtpArticle && totalCount > 10)) && (
        <a
          href="#"
          className={cx('link_more', !inputStatus && 'type_input')}
          onClick={handleNclickMix(isSamePtpArticle ? NCLICK.MY_HOUSE.SAME_ARTICLE.MORE : NCLICK.MY_HOUSE.SIMILAR_ARTICLE.MORE, ptpArticleMoreInfoHandler)}
        >
          <span className={cx('title')}>매물 더보기</span>
          {<SvgMyhouseMainPtpArticleMore />}
        </a>
      )}
      {!inputStatus && (
        <a
          href={`${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/main/${houseNo}#pyeong`}
          className={cx('link_more', !inputStatus && 'type_input')}
          onClick={handleNclickMix(NCLICK.MY_HOUSE.SIMILAR_ARTICLE.SETTING)}
        >
          <span className={cx('title')}>면적 정보 입력하기</span>
        </a>
      )}
    </div>
  )
}

export default MyhousePtpArticle
